import PrintPreferenceTabs from "../templete/PrintPreferenceTabs";
const DeliveryNote = () => {
  return (
    <PrintPreferenceTabs type="delivery_note"></PrintPreferenceTabs>
  );
};
export default DeliveryNote;
